/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NumberResponse } from '../../models/number-response';

export interface GalleryByProfileId$Params {
  id: number;
}

export function galleryByProfileId(http: HttpClient, rootUrl: string, params: GalleryByProfileId$Params, context?: HttpContext): Observable<StrictHttpResponse<NumberResponse>> {
  const rb = new RequestBuilder(rootUrl, galleryByProfileId.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<NumberResponse>;
    })
  );
}

galleryByProfileId.PATH = '/rest/profile/{id}/gallery';
